import { NodeType } from 'Automations/nodeDefinitions/types'

export type ActionType =
  | 'PUBLISH_QUOTE'
  | 'CREATE_SCHEDULE'
  | 'CONTRACT_EXTRACTION'

export const actionTypeLabel: Record<ActionType, string> = {
  PUBLISH_QUOTE: 'Publish quote',
  CREATE_SCHEDULE: 'Create schedule',
  CONTRACT_EXTRACTION: 'Contract extraction'
}

export const actionTypeTargetDefinition: Record<ActionType, NodeType> = {
  PUBLISH_QUOTE: 'ACTION_PUBLISH_QUOTE',
  CREATE_SCHEDULE: 'ACTION_CREATE_SCHEDULE',
  CONTRACT_EXTRACTION: 'ACTION_CONTRACT_EXTRACTION'
}
